import React, { useState, useEffect } from 'react';
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import 'primeicons/primeicons.css';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import { Button } from 'primereact/button';
import ShowError from '../shared/ShowError';
import Laoding from '../shared/Laoding';
import { InputNumber } from 'primereact/inputnumber';
        

export default function ShowMyWallet(props) {
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState("");
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [loadingIpgs, setLoadingIpgs] = useState(true);
    const [saving, setSaving] = useState(false);
    const [ipgs, setIpgs] = useState([]);
    const [increaseAmount, setIncreaseAmount] = useState(0);
    const [increaseAmountToman, setIncreaseAmountToman] = useState(0);
    const [walletAmount, setWalletAmount] = useState(0);
    const [displayMode, setDisplayMode] = useState(0);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [minIncreaseAmount, setMinIncreaseAmount] = useState(0);

    useEffect(() => {
        setLoadingIpgs(true);
        var params = {
            login:util.getLoginDto(), 
        };
        var url = config.Server+`/payment/ipg-list-with-wallet/get`;
        
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                console.log("resopnse is> ", response); 
                if(response.ipgs.length > 0){              
                    for(var i=0;i<response.ipgs.length;i++){
                        response.ipgs[i]["isChecked"] = false;
                    }
                    response.ipgs[0].isChecked = true;
                }
                else{
                    setSelectedIndex(-1);
                }
                setMinIncreaseAmount(response.minIpgAmount);
                setIpgs(response.ipgs);
                setWalletAmount(response.walletAmount);
                setLoadingIpgs(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                //setLoading(false);
            }
        })
        .catch(error => {
        console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            //setLoading(false);
        });
    }, []);
    
    const onBackButtonClick = function(){
        setDisplayMode(0);
    }
    const increaseWalletAmountClick = function (){
        if(ipgs.length == 0){
            setErrorMessage("درگاه پرداخت فعال یافت نشد");
            setErorVisible(true);
            return;
        }
        setDisplayMode(1);
    }
    const onContinueButtonClick = function(){
        var url = config.Server;
        if(ipgs[selectedIndex].ipgType.id == util.IpgTypes.Zarinpal){
            url += `/payment/zarinpal/payment/request`;
        }
        else{
            alert("undefined ipg");
            return;
        }
        console.log("ipg is>", ipgs[selectedIndex])
        util.saveIpgTransactionAmount(increaseAmount);
        util.saveIpgTransactionType(util.WallerTransactionTypes.IncreaseWalletAmount);
        util.saveBeforeIpgUrl("IncreaseWalletAmount");
        var params = {};
        params = {
            login:util.getLoginDto(), 
            ipgType:ipgs[selectedIndex].ipgType.id,
            type:util.WallerTransactionTypes.IncreaseWalletAmount,
            contractId:"",
            companyDetail:{isPersonal:true, personNationalId:"", economicCode:"",companyNationalId:"", title:"", url:""},
            productId:"",
            modules:[],
            parameters:[],
            cityId:"",
            discountToken:"",
            reagentMobile:"",
            fixAmount:increaseAmount,
            otherSystemIdentity:"",
        };
        console.log("params in ipg is>", params);
        console.log("url in ipg is>", url);
        
        setSaving(true);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                console.log("resopnse is> ", response);
                document.location = response;
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
        });
        
    }
    const onIpgSelected = function (index){
        var newIpgs = [...ipgs];
        for(var i=0;i<newIpgs.length;i++){
            newIpgs[i].isChecked = false;
        }
        if(index>=0){
            newIpgs[index].isChecked = true;
        }
        else{

        }
        setSelectedIndex(index);
        setIpgs(newIpgs);
        console.log("ipgs is>", ipgs);
    }
    const onInputChanged = function(e){
        if(e.value){
            setIncreaseAmount(e.value);
            if(e.value<10){
                setIncreaseAmountToman(0);
            }
            else{
                var t = parseInt(Math.floor(e.value/10));
                setIncreaseAmountToman(t);
            }
        }
        else{
            setIncreaseAmount(0);
            setIncreaseAmountToman(0);
        }
    }
    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :
        (loadingIpgs)?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <Laoding showLable={true} label="در حال دریافت مشخصات کیف پول..." />
                </Col>
            </Row>
        </>
        :
        (displayMode == 0)?
        <>
            <Row style={{padding:"0px", margin:"20px 0px 0px 0px", position:"relative"}}>
                
                <Col className="d-flex justify-content-center align-items-center" style={{}}>
                    <Col md={3} style={{border:"1px solid #b0b0b0", padding:"10px", borderRadius:"10px", position:"relative"}}>
                        <table style={{width:"100%", minWidth:"250px", marginLeft:"auto", marginRight:"auto"}}>
                            <tbody>
                                <tr>
                                    <td style={{width:"100%", textAlign:"center"}} colSpan={2}>
                                        <img style={{width:"64px"}} src={require("../lib/ipg logo/wallet.png")} alt="کیف پول" />
                                        {/* <span style={{fontSize:"4em", textAlign:"center"}} className="pi pi-user"></span> */}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{fontSize:"1.5em", textAlign:"center"}} colSpan={2}>کیف پول</td>
                                </tr>
                                <tr><td style={{borderBottom:"1px dashed #b0b0b0"}} colSpan={2}>&nbsp;</td></tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr><td style={{textAlign:"center"}} colSpan={2}>مانده:</td></tr>
                                <tr><td style={{textAlign:"center", paddingTop:"20px", fontSize:"1.3rem"}} colSpan={2}>{util.toPersianDigits(util.SeperatePrice(walletAmount))} ریال</td></tr>
                                <tr><td style={{borderBottom:"1px dashed #b0b0b0"}} colSpan={2}>&nbsp;</td></tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                        <Button severity="success" loading={saving} onClick={()=>{increaseWalletAmountClick()}} style={{borderRadius:"5px"}}>&nbsp;&nbsp;افزایش موجودی&nbsp;&nbsp;</Button>
                                        
                                    </td>
                                    <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                        <Button severity="primary" loading={saving} onClick={()=>{setRedirectUrl("/my-wallet/transaction/list")}} style={{borderRadius:"5px"}}>&nbsp;&nbsp;مشاهده گردش&nbsp;&nbsp;</Button>
                                        
                                    </td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>

                            </tbody>
                        </table>
                    </Col>
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
        :
        <>
            <Row style={{padding:"0px", margin:"20px 0px 0px 0px", position:"relative"}}>
                
                <Col className="d-flex justify-content-center align-items-center" style={{}}>
                    <Col md={3} style={{border:"1px solid #b0b0b0", padding:"10px", borderRadius:"10px", position:"relative"}}>
                        <img src={require("../lib/images/back.png")} alt='برگشت' onClick={()=>{onBackButtonClick()}} style={{width:"48px", height:"32px", position:"absolute", top:"5px", right:"10px", cursor:"pointer"}} />
                        <table style={{width:"100%", minWidth:"250px", marginLeft:"auto", marginRight:"auto"}}>
                            <tbody>
                                <tr>
                                    <td style={{width:"100%", textAlign:"center"}}>
                                        <img style={{width:"64px"}} src={require("../lib/ipg logo/wallet.png")} alt="کیف پول" />
                                        {/* <span style={{fontSize:"4em", textAlign:"center"}} className="pi pi-user"></span> */}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{fontSize:"1.5em", textAlign:"center"}}>افزایش موجودی کیف پول</td>
                                </tr>
                                <tr><td style={{borderBottom:"1px dashed #b0b0b0"}}>&nbsp;</td></tr>
                                <tr>
                                    <td style={{textAlign:"center", paddingTop:"15px"}}>
                                        حداقل افزایش موجودی مبلغ {util.toPersianDigits(util.SeperatePrice(minIncreaseAmount))} ریال می باشد
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{textAlign:"center", paddingTop:"15px"}}>
                                        میزان افزایش موجودی
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{textAlign:"center", paddingTop:"5px"}}>
                                        <InputNumber value={increaseAmount} onChange={(e) => {onInputChanged(e)}} onValueChange={(e) => {onInputChanged(e)}} minFractionDigits={0} maxFractionDigits={0} style={{direction:"ltr", textAlign:"center"}} />
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{textAlign:"center", paddingTop:"5px", color:(increaseAmount>=minIncreaseAmount)?"#0e810eff":"#d81616ff"}}>
                                        {util.toPersianDigits(util.SeperatePrice(increaseAmountToman))}&nbsp;تومان
                                    </td>
                                </tr>
                                {
                                    (increaseAmount>=minIncreaseAmount)?
                                <>
                                <tr><td style={{borderBottom:"1px dashed #b0b0b0"}}>&nbsp;</td></tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr><td>درگاه پرداخت را انتخاب نمائید</td></tr>
                                <tr>
                                    <td style={{position:"relative"}}>
                                        {
                                            ipgs.map((ipg, pInd)=>{
                                                return(
                                                    <>
                                                    <div onClick={()=>{onIpgSelected(pInd)}} style={{width:"calc(50% - 30px)", cursor:"pointer", minHeight:"100px", margin:"10px", borderRadius:"10px", float:"right", border:ipg.isChecked?"3px solid #3344ee":"1px dashed #b0b0b0", boxSizing:"border-box", padding:"10px", textAlign:"center"}}>
                                                        <img style={{width:"96px", height:"127px"}} src={require("../lib/ipg logo/" + ipg.logo)} alt="درگاه" />
                                                    </div>
                                                    </>
                                                )
                                            })
                                        }

                                    </td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                        <Button severity="success" loading={saving} onClick={()=>{onContinueButtonClick()}} style={{borderRadius:"5px"}}>&nbsp;&nbsp;تائید و پرداخت&nbsp;&nbsp;</Button>
                                        
                                    </td>
                                </tr>
                                </>
                                :
                                <></>
                                }
                                <tr><td>&nbsp;</td></tr>

                            </tbody>
                        </table>
                    </Col>
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    )
}